import { Button, Spinner } from '@/shared/ui'

import { useTossWidget } from '../../lib/toss-widget'

export const PaymentButton = () => {
  const { isWidgetReady, requestPayment, confirmPayment, isConfirming } =
    useTossWidget()

  const handleClick = async () => {
    const result = await requestPayment()

    if (result) {
      confirmPayment(result)
    }
  }

  return (
    <>
      <Button
        size="large"
        fullWidth
        disabled={!isWidgetReady}
        onClick={handleClick}
      >
        결제하기
      </Button>
      {isConfirming && <Spinner className="rounded-xl bg-black/20" />}
    </>
  )
}
